import { render, staticRenderFns } from "./edit-delivery.vue?vue&type=template&id=b76fa79a&"
import script from "./edit-delivery.vue?vue&type=script&lang=js&"
export * from "./edit-delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports